import React from 'react';
import styles from './TipBoxBottom.module.scss';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../../../utils/translations/translator';

/* Providers */
import { useShopContext } from '../../../../shared/__providers__/ShopContext';

/* Components */
import { TipValueWithLabel } from '../../TipValueWithLabel/TipValueWithLabel';

/* Interfaces */
import { PremiumTipProduct, TipProduct } from '../../../interfaces/TipProduct';
import { Confidence } from './Confidence';

interface TipBoxBottomProps {}

export const TipBoxBottom: React.FC<TipBoxBottomProps> = () => {
  const { shop } = useShopContext();
  const { t } = useTranslation();
  const tip = shop!.selectedProduct as TipProduct | PremiumTipProduct;

  return (
    <>
      {tip && (
        <div className={styles.innerBottomBox}>
          <Confidence confidence={tip.tip.confidence} stake={tip.tip.stake} />

          <TipValueWithLabel label={tr(t, 'odd')}>
            {tip.tip.rate}
          </TipValueWithLabel>
          <div className={styles.bookieTag}>
            <div className={styles.bookieTagInner}>
              <label>
                {tr(t, 'bet_done_at')} <span>{tip.tip.bookie}</span>
              </label>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
